import * as Sentry from "@sentry/react";
import { SENTRY_DSN } from "../config/default";

/**
 * Initialize Sentry Error Tracking and Performance Monitoring
 */
export const initSentry = () => {
  try {
    if (!SENTRY_DSN) {
      console.warn("[Sentry] No DSN provided, skipping initialization");
      return;
    }

    Sentry.init({
      dsn: SENTRY_DSN,
      integrations: [
        Sentry.browserTracingIntegration(),
        Sentry.replayIntegration(),
      ],
      // Tracing
      tracesSampleRate: 1.0, // Capture 100% of the transactions for performance monitoring
      // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
      tracePropagationTargets: ["localhost", /^https:\/\/api\.manabakh\.ir\/api/],
      // Session Replay
      replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%
      replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur
    });
    console.log("[Sentry] Initialized successfully");
  } catch (error) {
    console.warn("[Sentry] Initialization failed:", error);
  }
};
